import React from 'react';
import { Image } from 'semantic-ui-react';

import goldTrophy from '../img/icon-trophy-gold.png';
import silverTrophy from '../img/icon-trophy-silver.png';

import '../css/Trophy.less';

import { register } from '../i18n';
import { SatCoreRegister } from '../SatCoreRegistry';

const t = register('Trophy');

const TROPHY_IMAGE_BY_ID = {
  gold: goldTrophy,
  silver: silverTrophy
};

const getTierTranslationKey = (tierId, suffix) => {
  const tierKey = tierId.charAt(0).toUpperCase() + tierId.slice(1);
  return `trophy${tierKey}${suffix}`;
};

const Trophy = (({ tier, count } = {}) => {
  if (!tier?.id) {
    return null;
  }

  const { id: tierId, showBand = true } = tier;
  const trophyImg = tier.imageUrl || TROPHY_IMAGE_BY_ID[tierId];
  const trophyImgLabel = t(getTierTranslationKey(tierId, 'ImgLabel'));
  const label = t(getTierTranslationKey(tierId, 'Label'), tierId);
  const rangeLabel = t(getTierTranslationKey(tierId, 'RangeLabel'));
  const bandClass = `${tierId}-band`;

  return (
    <div className={`trophy${showBand ? '' : ' no-band'}`} tabIndex={0}>
      {!!trophyImg && (
        <Image alt={trophyImgLabel} className='trophy-img' src={trophyImg} />
      )}
      {showBand ? (
        <>
          <div aria-label={`${count} ${label}.`} className={`trophy-count ${bandClass}`}>
            {count}
            {' '}
            {label}
          </div>
          <div aria-hidden={true} className='trophy-range'>{rangeLabel}</div>
        </>
      ) : (
        <div aria-label={`${count} ${label}.`} className='trophy-count-plain'>
          <div className='trophy-count-value'>{count}</div>
          <div className='trophy-label'>{label}</div>
        </div>
      )}
    </div>
  );
});

export default Trophy;

SatCoreRegister('Trophy', Trophy);
